function RecebimentoOdometro(KM) {
    let kmInteiro = 0;
    try {
        let kmSomenteNumeros = KM.toString().replace(/\D+/g, "");
        kmInteiro = parseInt(kmSomenteNumeros);
    } catch (error) {
        console.error("ERROR-KM-ODOMETRO", error);
    }
    return kmInteiro;
}

export const makeDataSendInsp = (data, photos) => {
    const enterpriseData = data.enterprise;
    const inspectionData = data.inspectionData;
    const vist_id = data.id_vistoria;

    let idQuestionario = null;

    if (inspectionData.quizId) {
        idQuestionario = inspectionData.quizId;
    }

    let questionnaire = inspectionData.quizType;
    const dateAndHour = data.date + " " + data.hour;
    const tires = questionnaire === "MOTO" ? 2 : 5;
    const inspectionType = parseInt(inspectionData.operation.tipo_vistoria);

    const timestamp = (new Date()).toLocaleString("pt-BR").replaceAll(",", "");
    const dataObj = {
        vist_id,
        AnoDocumentoCRLV: inspectionData.data.CRLV ?? null,
        Arquivo: data.id_vistoria,
        AssinClienteRealizada: 0,
        AssinaturaCliente: {
            Data: "",
            Email: "",
            Nome: inspectionData.clientFullName  ?? null,
            Rg: inspectionData.clientRg ?? null,
            Telefone: inspectionData.clientPhoneNumber ?? null,
        },
        AssinaturaEntrega: {
            Data: null,
            Email: "",
            Nome: "",
            Rg: "",
            Telefone: "",
        },
        Avarias: [],
        Bateria: inspectionData.data?.Bateria?.estado ?? null,
        CamposPersonalizados : [],
        CRLV: "Sim",
        Cidade: inspectionData.data["Cidade Atendimento"] ?? null,
        Cliente: inspectionData.data?.clientName  ?? null,
        Contato: inspectionData.data["Contato Local"]  ?? null,
        DataAssinaturaVistoriador: "05/02/2021 10:54:27",
        DataHora: dateAndHour ?? timestamp,
        DataHoraFim: timestamp,
        Destino: inspectionData.data["Destino Entrega"] ?? null,
        DestinoCidade: inspectionData.data["Cidade Entrega"] ?? null,
        DeviceData: {
            Base: 1,
            Board: "",
            Brand: "",
            DeviceId: "",
            Display: "",
            FreeMemory: 0,
            Hardware: "",
            Host: "",
            Manufacturer: "",
            SDKVersion: "",
            Serial: "",
            TabletName: "",
            TotalMemory: 0,
            Type: "",
            User: "",
            VersionCode: "",
            VersionIncremental: "",
            VersionRelease: "",
        },
        Email: inspectionData.data?.clientEmail || "",
        Empresa: {
            Endereco: "",
            Id: enterpriseData.idEnterprise,
            MinimoFotos: 1,
            Nome: enterpriseData.name,
            TabletId: "359539092878770",
            TabletName: "VexWebBeta",
            Telefone: "",
            UrlApi: null,
            Token: enterpriseData.enterprise,
            UtilizaAPIIntegracao: false,
            UtilizaAssinaturaDupla: false,
            UtilizaConsultaApiVistoria: false,
        },
        EntregaRealizada: true,
        Enviado: 0,
        FoneCliente: "",
        Fotos: photos,
        IdPreVistoria: 0,
        Identificacao: "",
        InstruidoRemoverPertences: "",
        Local: inspectionData.data["Local Atendimento"] ?? null,
        Lote: 0,
        MarcaBateria:
            inspectionData.data?.Bateria?.marca == "Outra"
                ? inspectionData.data.Bateria.outraMarca
                : inspectionData.data?.Bateria?.marca ?? "",
        Motorista: inspectionData.data.Motorista ?? null,
        NumeroFrota: inspectionData.data.Frota,
        Observacao: inspectionData.data["observacao"] || "",
        ObservacaoColeta: inspectionData.data["observacaoColeta"] || "",
        PesquisaSatisfacao: "",
        Produto: inspectionData.data?.Produto ?? null,
        Respostas: [...inspectionData.quiz],
        Retirar: inspectionData.data["Pertences Retirados"] ?? null,
        Servico: inspectionData.data["Tipo de servico"] ?? null,
        Sinistro: inspectionData.data.Sinistro,
        SituacaoLocalAtendimento: inspectionData.data["Situação Local de Atendimento"] ?? null,
        Tipo: inspectionType,
        TipoVeiculo: {
            Id: idQuestionario,
            ImageFull: 2131230835,
            ImageMin: 2131230820,
            Nome: inspectionData.quizType,
            QtdePneus: tires,
        },
        TokenVistoria: "",
        ValorServico: inspectionData.data["Valor Servico"] ?? null,
        Veiculo: {
            Ano: inspectionData.data?.Ano ?? null,
            CapacidadeGNV: inspectionData.data["Capacidade do GNV"] ?? null,
            Chassi: inspectionData.data?.Chassi ?? "",
            Cor: inspectionData.data?.Cor ?? null,
            DocumentoAtualizadoGNV: inspectionData.data["Documento Atualizado GNV"] ?? null,
            Nivel:
                inspectionData.data?.["Nivel Combustivel"]
                    ? Math.floor(inspectionData.data["Nivel Combustivel"])
                    : 0,
            NivelGNV: inspectionData.data["Nivel do GNV"] ?? null,
            Nome: inspectionData.data?.vehicle ?? null,
            Odometro:
                inspectionData.data["Km Odometro"]
                    ? RecebimentoOdometro(inspectionData.data["Km Odometro"])
                    : 0,
            Placa: inspectionData.numberPlate,
            PneuDianteiroDireito: {
                Marca: inspectionData.data?.Pneus?.["Dianteiro Direito"]
                    ? inspectionData.data.Pneus["Dianteiro Direito"].Marca
                    : inspectionData.data?.Pneus?.["Dianteiro"]?.Marca ?? null,
                Situacao: inspectionData.data?.Pneus?.["Dianteiro Direito"]
                    ? inspectionData.data.Pneus["Dianteiro Direito"].Estado
                    : inspectionData.data?.Pneus?.["Dianteiro"].Estado ?? null,
            },
            PneuDianteiroEsquerdo: {
                Marca: inspectionData.data.Pneus?.["Dianteiro Esquerdo"]
                    ? inspectionData.data.Pneus["Dianteiro Esquerdo"].Marca
                    : null,
                Situacao: inspectionData.data.Pneus?.["Dianteiro Esquerdo"]
                    ? inspectionData.data.Pneus["Dianteiro Esquerdo"].Estado
                    : null,
            },
            PneuEstepe: {
                Marca: inspectionData.data.Pneus?.["Estepe"]
                    ? inspectionData.data.Pneus["Estepe"].Marca
                    : null,
                Situacao: inspectionData.data.Pneus?.["Estepe"]
                    ? inspectionData.data.Pneus["Estepe"].Estado
                    : null,
            },
            PneuTraseiroDireito: {
                Marca: inspectionData.data.Pneus?.["Traseiro Direito"]
                    ? inspectionData.data.Pneus["Traseiro Direito"].Marca
                    : inspectionData.data.Pneus?.["Traseiro"]?.Marca ?? null,
                Situacao: inspectionData.data.Pneus?.["Traseiro Direito"]
                    ? inspectionData.data.Pneus["Traseiro Direito"].Estado
                    : inspectionData.data.Pneus?.["Traseiro"]?.Estado ?? null,
            },
            PneuTraseiroEsquerdo: {
                Marca: inspectionData.data.Pneus?.["Traseiro Esquerdo"]
                    ? inspectionData.data.Pneus["Traseiro Esquerdo"].Marca
                    : null,
                Situacao: inspectionData.data.Pneus?.["Traseiro Esquerdo"]
                    ? inspectionData.data.Pneus["Traseiro Esquerdo"].Estado
                    : null,
            },
            Situacao: inspectionData.data?.["Situação do Veículo"] ?? null,
        },
        VersaoAppCode: 1,
        VersaoAppName: "VEX WEB",
        Vistoriador: enterpriseData.name,
        _id: 0,
        contrato: inspectionData.data?.["Numero Contrato"] ?? null,
        coord_gps: inspectionData.coordGps,
        idQuestionario: idQuestionario,
        idUsuario: enterpriseData.id,
        tipoOperacaoId: inspectionData.operation.id,
        versaoDeDados: localStorage.getItem("versaoDeDados"),
    };

    return dataObj;
};
